<template>
  <section>
    <div class="top">
      <div class="allTitle" style="fontsize: 18px; margin-left: 30px">
        数据统计
      </div>
      <div class="tabs">
        <div
          class="item"
          style="background: linear-gradient(48deg, #a87aff 6%, #7151ed 93%)"
        >
          <div class="status">待处理工单</div>
          <div class="nums">
            <span class="num1">{{ wkStatics.accepting }}</span>
            <span class="num2">/{{ wkStatics.total }}</span>
          </div>
        </div>
        <div
          class="item"
          style="background: linear-gradient(48deg, #7a81ff, #6345ff 89%)"
        >
          <div class="status">已处理工单</div>
          <div class="nums">
            <span class="num1">{{ wkStatics.waitingForFeedback }}</span>
            <span class="num2">/{{ wkStatics.total }}</span>
          </div>
        </div>
        <div
          class="item"
          style="background: linear-gradient(46deg, #5c8bff, #0095ff 93%)"
        >
          <div class="status">已关闭工单</div>
          <div class="nums">
            <span class="num1">{{ wkStatics.closed }}</span>
            <span class="num2">/{{ wkStatics.total }}</span>
          </div>
        </div>
        <div
          class="item"
          style="background: linear-gradient(51deg, #5c8bff 4%, #356df9 95%)"
        >
          <div class="status">处理中的工单</div>
          <div class="nums">
            <span class="num1">{{ wkStatics.processing }}</span>
            <span class="num2">/{{ wkStatics.total }}</span>
          </div>
        </div>
      </div>
    </div>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
      @onPageChange="pageChange"
    >
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">
            快速筛选
            <el-input
              style="padding-left: 20px; width: 310px !important"
              maxlength="50"
              placeholder="输入问题标题/问题描述搜索"
              clearable
              size="medium"
              v-model.trim="filters.keyword"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">工单编号</div>
                <el-input
                  v-model="filters.wkOrderId"
                  placeholder="编号"
                  oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">审批状态</div>
                <el-select v-model="filters.handleResult" placeholder="全部">
                  <el-option
                    v-for="(item, index) in handleResultOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单状态</div>
                <el-select v-model="filters.status" placeholder="全部">
                  <el-option
                    v-for="(item, index) in statusOptions"
                    :key="index"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交时间</div>
                <el-date-picker
                  v-model="timeQuantum"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="timestamp"
                  @change="handleTimeChange"
                >
                </el-date-picker>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单分类</div>
                <el-select
                  v-model="filters.parentQaTypeId"
                  @change="handleWkOrderChange"
                  placeholder="请选择工单分类"
                >
                  <el-option
                    v-for="item in wkOrderTypeOptions"
                    :key="item.parentTypeId"
                    :label="item.parentQaTypeName"
                    :value="item.parentTypeId"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单类型</div>
                <el-select
                  v-model="filters.qaTypeId"
                  :disabled="!filters.parentQaTypeId"
                  :placeholder="
                    wkOrderTypeId ? '请选择工单类型' : '请先选择工单分类'
                  "
                >
                  <el-option
                    v-for="item in qaTypeOptions"
                    :key="item.qaTypeId"
                    :label="item.qaTypeName"
                    :value="item.qaTypeId"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="filter-item">
                <div class="demonstration">工单来源</div>
                <el-select
                  v-model="filters.sourceChannel"
                  placeholder="工单来源"
                >
                  <el-option :value="0" label="呗呗表单"></el-option>
                  <el-option :value="1" label="页面填写"></el-option>
                  <el-option :value="2" label="美呗通客户端"></el-option>
                  <el-option :value="3" label="智能分单"></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">优先级</div>
                <el-select v-model="filters.priority" placeholder="优先级">
                  <el-option
                    v-for="(label, value) in priorityEnum"
                    :key="label"
                    :value="value"
                    :label="label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">标签</div>
                <el-cascader
                  v-model="labelSelected"
                  :options="tagsOptions"
                  :props="{
                    label: 'label',
                    value: 'id',
                    children: 'childList',
                    multiple: true,
                  }"
                  @change="labelChange"
                  clearable
                  collapse-tags
                  filterable
                  :show-all-levels="false"
                ></el-cascader>
              </div>
              <div class="filter-item">
                <div class="demonstration">承接人</div>
                <el-input v-model="filters.acceptorName"></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交人</div>
                <el-input v-model="filters.authorName"></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">客户</div>
                <el-input v-model="filters.customer"></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">相关机构</div>
                <el-input v-model.trim="filters.companyInfo"></el-input>
              </div>
              <div class="filter-item buttons">
                <el-button
                  type="primary"
                  size="small"
                  class="query-btn"
                  @click="handleSearch"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  class="reset"
                  @click="handleClearSearchForm"
                  >重置</el-button
                >
                <!-- <el-button type="primary" size="small" class="query-btn" @click="handleExport">导出数据</el-button>
                                 -->
                <el-button
                  type="primary"
                  size="small"
                  class="query-btn"
                  @click="upLoadDialog"
                  >导出数据</el-button
                >
              </div>
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column
          label="工单编号"
          prop="wkOrderId"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="问题标题"
          show-overflow-tooltip
          prop="wkOrderTopic"
        ></el-table-column>
        <el-table-column
          label="工单类型"
          prop="qaTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="提交人" prop="authorName"></el-table-column>
        <el-table-column label="承接人" prop="acceptorName"></el-table-column>
        <el-table-column
          label="提交时间"
          prop="submitTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="审批状态"
          prop="handleResult"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.handleResult"
              size="mini"
              :type="handleResultEnum[scope.row.handleResult].type"
            >
              {{ handleResultEnum[scope.row.handleResult].label }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="工单状态" prop="statusName">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusEnum[scope.row.status].type">
              {{ statusEnum[scope.row.status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="受理时间"
          prop="acceptTime"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.acceptTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="优先级"
          prop="priority"
          :formatter="(row) => priorityEnum[row.priority]"
        ></el-table-column>
        <el-table-column label="标签" prop="labelName" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.labelName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="相关机构"
          prop="companyInfo"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.companyInfo || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="工单来源"
          prop="sourceChannel"
          :formatter="(row) => sourceChannelEnum[row.sourceChannel]"
        ></el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="{ row }">
            <el-button
              @click="
                () => {
                  goDetail(row);
                }
              "
              type=" text"
              size="small"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </template>
    </m-table-list>
    <el-dialog title="请选择导出的数据模式" :visible.sync="showDialog">
      <div>
        <el-radio-group v-model="form.priority" @change="handerGetNum">
          <div class="flex-wap">
            <el-radio
              label="worKdetils"
              class="flex-main"
              :class="form.priority == 'worKdetils' ? 'act' : ''"
              :style="{ borderColor: form.priority ? '#faf5f5' : 'red' }"
            >
              <p>工单流程细节数据</p>
              <p>一条工单可能导出多行数据，每行数据代表工单的一次操作记录。</p>
            </el-radio>
            <el-radio
              label="workAll"
              class="flex-main"
              :class="form.priority == 'workAll' ? 'act' : ''"
              :style="{ borderColor: form.priority ? '#faf5f5' : 'red' }"
            >
              <p>工单整体数据</p>
              <p>一条工单只会导出一行数据，包含工单的所有重要信息。</p>
            </el-radio>
          </div>
        </el-radio-group>
        <div class="flex-wap" v-if="form.priority">
          预计导出<span class="color-type">{{ unmList.workOrderNum }}</span
          >条工单，共<span class="color-type">{{ unmList.rowsNum }}</span
          >行数据。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" plain @click="showDialog = false"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="updateRelationList"
          >导 出</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";
import {
  statusEnum,
  statusOptions,
  priorityEnum,
  handleResultEnum,
  handleResultOptions,
} from "@/components/data.js";

export default {
  name: "workmange.workOrderList.list",
  components: {
    "m-table-list": tableList,
  },
  data() {
    return {
      showDialog: false,
      timeQuantum: [],
      form: {
        priority: "",
      },
      filters: {
        authorName: "",
        createTimeBegin: "",
        createTimeEnd: "",
        qaTypeId: "",
        remark: "",
        status: "",
        wkOrderId: "",
        parentQaTypeId: "",
        priority: "",
        label: [],
        sourceChannel: "",
        acceptorName: "",
        handleResult: null,
        customer: "",
        companyInfo: "",
        keyword: "",
      },
      sourceChannelEnum: {
        IM: "呗呗表单",
        PAGE_SUBMISSION: "页面填写",
        MBT: "美呗通客户端",
        FENDAN_WAREHOUSE: "智能分单",
        YXGL: "营销管理系统",
      },
      wkOrderTypeId: undefined,
      wkOrderTypeOptions: [],
      wkStatics: {
        accepting: 0,
        closed: 0,
        reject: 0,
        total: 0,
        waitingForFeedback: 0,
      },
      time: "",
      qaTypeOptions: [],
      groupOptions: [],
      userOptions: [],
      formData: {
        groupId: "",
        recvId: "",
        remark: "",
        strategy: "SHARE",
        transferType: "Out",
        wkOrderId: "",
      },
      labelSelected: [],
      tagsOptions: [],
      dialogTableVisible: false,
      wkGroupId: "",
      unmList: {},
      statusOptions,
      priorityEnum,
      statusEnum,
      handleResultEnum,
      handleResultOptions,
    };
  },
  computed: {},
  async activated() {
    const filterStr = sessionStorage.getItem("workOrderListFilter");
    const pageStr = sessionStorage.getItem("pageSetting");
    let page = 1;
    let size = 10;
    if (pageStr) {
      page = JSON.parse(pageStr).page;
      size = JSON.parse(pageStr).size;
    }
    if (filterStr) {
      this.filters = JSON.parse(filterStr);
      if (this.filters.parentQaTypeId) {
        await this.handleWkOrderChange(this.filters.parentQaTypeId, true);
      }
      this.$nextTick(() => {
        this.$refs.tableList.handleSearchByPage(page, size);
      });
    }

    this.getWkOrderStatistics();
    this.getworkorderparenttypelist();
  },
  methods: {
    fetchListFunc: api.workmanage.getManageWkOrderList,

    pageChange(data) {
      sessionStorage.setItem("pageSetting", JSON.stringify(data));
    },
    upLoadDialog() {
      this.showDialog = true;
      this.form.priority = "";
    },
    handerGetNum(e) {
      let b = api.workmanage.exportDetailsCount(this.filters);
      if (e == "workAll") {
        b = api.workmanage.exportWholeCount(this.filters);
      }
      return b.then((res) => {
        this.unmList = res.data.data;
      });
    },
    updateRelationList() {
      if (!this.form.priority) return;
      let b = api.workmanage.exportDetails(this.filters);
      if (this.form.priority == "workAll") {
        b = api.workmanage.exportWhole(this.filters);
      }
      return b.then((res) => {
        const blob = new Blob([res.data]);
        const fileName = "工单列表数据.xlsx";
        const linkNode = document.createElement("a");
        linkNode.download = fileName;
        linkNode.style.display = "none";
        linkNode.href = URL.createObjectURL(blob);
        document.body.appendChild(linkNode);
        linkNode.click();
        URL.revokeObjectURL(linkNode.href);
        document.body.removeChild(linkNode);
      });
    },
    getWkOrderStatistics() {
      return api.workmanage.getManageWorkOrderStatistics().then((res) => {
        this.wkStatics = res.data.data;
      });
    },
    labelChange(v) {
      if (!v) {
        this.filters.label = [];
      } else {
        const groupId = [...new Set(v.map((item) => item[0]))];
        const childrenId = v.map((item) => item[1]);
        const result = groupId.map((item) => {
          return {
            labelGroupId: item,
            labelNames: this.tagsOptions
              .filter((parent) => parent.id === item)[0]
              .childList.filter((item) => childrenId.includes(item.id))
              .map((item) => item.label),
          };
        });
        this.filters.label = result;
      }
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
      this.timeQuantum = [];
      this.labelSelected = [];
      sessionStorage.setItem("workOrderListFilter", "");
    },
    async handleWkOrderChange(val, isReload = false) {
      if (!isReload) {
        this.filters.qaTypeId = undefined;
      }
      await api.dropDownList.getWorkType({ id: val }).then((res) => {
        this.qaTypeOptions = res.data.data;
      });
    },
    handleTimeChange(val) {
      if (val) {
        const startTime = val[0];
        const endTime = val[1] + 60 * 60 * 1000 * 24 - 1;
        this.filters.createTimeBegin = new Date(startTime);
        this.filters.createTimeEnd = new Date(endTime);
      } else {
        this.filters.createTimeBegin = "";
        this.filters.createTimeEnd = "";
        this.timeQuantum = [];
      }
    },
    getworkorderparenttypelist() {
      api.dropDownList.getWorkCut().then((res) => {
        this.wkOrderTypeOptions = res.data.data;
      });
      api.manage.getTagTree().then((res) => {
        this.tagsOptions = res.data.data;
      });
    },
    handleExport() {
      api.workmanage.exportWorkOrder(this.filters).then((res) => {
        const blob = new Blob([res.data]);
        const fileName = "工单列表数据.xlsx";
        const linkNode = document.createElement("a");
        linkNode.download = fileName;
        linkNode.style.display = "none";
        linkNode.href = URL.createObjectURL(blob);
        document.body.appendChild(linkNode);
        linkNode.click();
        URL.revokeObjectURL(linkNode.href);
        document.body.removeChild(linkNode);
      });
    },
    goDetail(row) {
      sessionStorage.setItem(
        "workOrderListFilter",
        JSON.stringify(this.filters),
      );
      this.$router.push({
        name: "workmange.workOrderList.detail",
        query: {
          wkOrderId: row.wkOrderId,
          id: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex-wap {
  width: 100%;
  padding-left: 80px;

  .color-type {
    color: #3572e2;
  }
}

.flex-main {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #faf5f5;
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 4px;
  width: 100%;
}

.top {
  background-color: white;
  height: 258px;
  width: 100%;
  padding-top: 30px;
  margin-bottom: 30px;

  .allTitle::before {
    margin-right: 8px;
    content: "";
    border-left: 4px solid #3572e2;
    height: 16px;
  }

  .tabs {
    margin-top: 23px;
    display: flex;
    justify-content: center;
    align-items: center;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      flex-direction: column;
      border-radius: 8px;
      width: 370px;
      height: 154px;
      margin-left: 33px;

      .nums {
        .num1 {
          font-size: 36px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 50px;
        }

        .num2 {
          font-size: 12px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 17px;
        }
      }

      .status {
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 28px;
      }
    }
  }
}

.act {
  border: 1px solid #409eff !important;
}

/deep/ .el-dialog {
  width: 750px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .el-dialog__body {
    padding: 0;

    .dialog-main-content {
      padding: 9px 24px 15px;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
      border-bottom: 1px solid rgba(0, 0, 0, 0.09);

      p {
        text-align: right;
        margin-bottom: 13px;
      }

      .create-form {
        .quality-item {
          display: flex;
          justify-content: space-around;
          margin-bottom: 20px;

          span {
            margin-right: 12px;
          }
        }
      }

      .el-input {
        width: 240px;
      }
    }

    /deep/ .btn-box {
      display: flex;
      justify-content: flex-end;
      padding: 20px 23px 26px;

      .cancel-btn {
        border-radius: 2px;
      }

      .confirm-btn {
        color: #fff;
        background: #1890ff !important;
        border-radius: 2px;
      }
    }
  }
}
</style>
